export const Menu = [
    { label: "Home", pathname: "/"},
    { label: "About Us", pathname: "about-us"},
    { label: "Services", pathname: "services"},
    { label: "Clients", pathname: "clients"},
    { label: "CSR", pathname: "csr"},
    { label: "Contact Us", pathname: "contact-us"}
]